import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export type ConversationMessageDto = {
    id: string;
    role: 'user' | 'assistant' | 'tool' | 'system';
    content: string;
    createdAt: string;
};

export type ConversationDetailDto = {
    id: string;
    senderPhone: string;
    user: {
        id: string;
        firstName: string;
        lastName: string;
    } | null;
    createdAt: string;
    updatedAt: string;
    messages: ConversationMessageDto[];
};

export const GET_CONVERSATION_QUERY_KEY = (conversationId: string) => [
    'whatsapp-conversation',
    conversationId,
];

export const useGetConversation = (
    organizationId: string,
    conversationId?: string,
) => {
    const client = useApiClient();

    return useQuery({
        queryKey: GET_CONVERSATION_QUERY_KEY(conversationId!),
        queryFn: () =>
            client.fetchApi<ConversationDetailDto, {}>({
                endpoint: `whatsapp-conversations/${organizationId}/${conversationId}`,
                method: 'GET',
            }),
        enabled: !!organizationId && !!conversationId,
    });
};
